import { render } from "./FilterTab.vue?vue&type=template&id=70a45c9e&scoped=true&ts=true"
import script from "./FilterTab.vue?vue&type=script&lang=ts"
export * from "./FilterTab.vue?vue&type=script&lang=ts"

import "./FilterTab.vue?vue&type=style&index=0&id=70a45c9e&lang=scss&scoped=true"
import "./FilterTab.vue?vue&type=style&index=1&id=70a45c9e&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a45c9e"]])

export default __exports__